import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=e9239460&scoped=true"
import script from "./info-box.vue?vue&type=script&lang=js"
export * from "./info-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9239460",
  null
  
)

export default component.exports